/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const StressedIcon = props => {
	const { color = '' } = props
	return (
		<svg
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			x={0}
			y={0}
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path
				className='st0'
				d='M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 48.2C12.2 48.3 1.8 37.8 1.8 25 1.8 12.2 12.2 1.8 25 1.8c12.8 0 23.2 10.4 23.3 23.2 0 12.8-10.4 23.2-23.3 23.2z'
			/>
			<path
				className='st0'
				d='M13.3 16.3c-.6-.4-1.4-.3-1.9.3-.2.3-.3.6-.2 1s.2.7.5.9l3.2 2.3-3.6 1.6c-.6.3-.9.9-.8 1.6.2.6.7 1 1.3 1h.3c.1 0 .1 0 .2-.1l8-3.4-7-5.2zM38.7 22.4l-3.6-1.6 3.2-2.3c.6-.4.7-1.3.3-1.9-.4-.6-1.3-.7-1.9-.3l-6.9 5 7.8 3.5c.1 0 .2.1.2.1h.3c.5 0 1-.3 1.2-.8.4-.6.1-1.4-.6-1.7zM30.1 28.5 25.6 33 21 28.6l-5.2 6.2c-.2.2-.3.5-.3.9 0 .7.6 1.3 1.3 1.3.4 0 .8-.2 1-.5l3.4-4 4.5 4.3 4.3-4.3 3.5 4c.5.6 1.3.6 1.9.1.6-.5.6-1.3.1-1.9l-5.4-6.2z'
			/>
		</svg>
	)
}

export default StressedIcon
